"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SbMenu = function SbMenu(props) {
  var className = props.className,
      children = props.children,
      id = props.id,
      style = props.style,
      isCollapsed = props.isCollapsed;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)('sb-menu sb-menu-left', {
      collapsed: isCollapsed
    }, className),
    id: id,
    style: style,
    role: "navigation"
  }, children);
};

exports.SbMenu = SbMenu;
SbMenu.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  id: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line
  isCollapsed: _propTypes.default.bool
};
SbMenu.defaultProps = {
  className: null,
  id: null,
  style: null,
  isCollapsed: false
};
//# sourceMappingURL=sb-menu.js.map